import { Actions } from './utilisateursActions';


/**
 * Etat initial utilisateur
 */
const initialState = {
    items: [],
    isLoading: false,
    error: '',
    suggestions: {
        items: [],
        isLoading: false,
        value: '',
        selectedId: 0
    }
};

/**
 * Reducer pour les utilisateurs
 */
const reducer = (namespace) => (state = initialState, action) => {

    switch (action.type) {
        // Récupération des utilisateurs d'un groupe
        case `${namespace}/${Actions.FETCH_UTILISATEURS_REQUEST}`:
            return {
                ...state,
                isLoading: true
            };
        case `${namespace}/${Actions.FETCH_UTILISATEURS_SUCCESS}`:
            return {
                ...state,
                items: [...action.items],
                isLoading: false
            };
        case `${namespace}/${Actions.FETCH_UTILISATEURS_FAILURE}`:
            return {
                ...state,
                isLoading: false,
                error: action.error
            };

        // Suggestion des utilisateurs
        case `${namespace}/${Actions.FETCH_SUGGESTIONS_UTILISATEUR_REQUEST}`:
            return {
                ...state,
                suggestions: { ...state.suggestions, isLoading: true }
            };
        case `${namespace}/${Actions.FETCH_SUGGESTIONS_UTILISATEUR_SUCCESS}`:
            return {
                ...state,
                suggestions: { ...state.suggestions, items: [...action.utilisateurs], isLoading: false }
            };
        case `${namespace}/${Actions.FETCH_SUGGESTIONS_UTILISATEUR_FAILURE}`:
            return {
                ...state,
                suggestions: { ...state.suggestions, isLoading: false, error: action.error }
            };
        case `${namespace}/${Actions.CLEAR_SUGGESTIONS_UTILISATEUR}`:
            return {
                ...state,
                suggestions: { ...state.suggestions, items: [], isLoading: false }
            };
        case `${namespace}/${Actions.SET_UTILISATEUR_VALUE}`:
            return {
                ...state,
                suggestions: { ...state.suggestions, value: action.value, selectedId: action.selectedId }
            };
        case `${namespace}/${Actions.CLEAR_UTILISATEUR_VALUE}`:
            return {
                ...state,
                suggestions: { ...state.suggestions, value: '', selectedId: 0 }
            };

                    

        default:
            return state;
    }
};

export default reducer;